export default __webpack_public_path__ + "static/media/account_circle.9fb558ee.svg";